import * as tslib_1 from "tslib";
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var GisToolsApi = /** @class */ (function () {
    function GisToolsApi(api) {
        this.api = api;
        this.districtProperties = 'id, districtNumber';
        this.countyProperties = 'id, countyCode, districtNumber';
    }
    GisToolsApi.prototype.getDistricts = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetDistricts($id: [Int]) {\n                districts(id: $id){\n                    " + this.districtProperties + "\n                }\n            }", { id: id }, 'GET', 'districts')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getCounties = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetCounties($id: [Int]) {\n                counties(id: $id){\n                    " + this.countyProperties + "\n                }\n            }", { id: id }, 'GET', 'counties')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getCountiesByDistricts = function (districtNumbers) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetCounties($districtNumbers: [String]) {\n                counties(districtNumber: $districtNumbers){\n                    " + this.countyProperties + "\n                }\n            }", { districtNumbers: districtNumbers }, 'GET', 'counties')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetDistricts {\n            districts {\n                " + props + "\n            }\n        }", {}, 'GET', 'districts')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllCounties = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetCounties {\n            counties {\n                " + props + "\n            }\n        }", {}, 'GET', 'counties')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllMunicipalities = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetMunicipalities {\n            municipalities {\n                " + props + "\n            }\n        }", {}, 'GET', 'municipalities')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllZipCodes = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetZipCodes {\n            zipCodes {\n                " + props + "\n            }\n        }", {}, 'GET', 'zipCodes')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllSchoolDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSchoolDistricts {\n            schooldistricts {\n                " + props + "\n            }\n        }", {}, 'GET', 'schooldistricts')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getMunicipalitiesByCounty = function (countyCode, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetMunicipalitiesByCounty($countyCode: [String]) {\n            municipalities(countyCode: $countyCode) {\n                " + props + "\n            }\n        }", { countyCode: countyCode }, 'GET', 'municipalities')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllPlanningPartners = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetPlanningPartners {\n            planningPartners {\n                " + props + "\n            }\n        }", {}, 'GET', 'planningPartners')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllHouseDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetHouseDistricts {\n            pahousedistricts {\n                " + props + "\n            }\n        }", {}, 'GET', 'pahousedistricts')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllSenateDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSenateDistricts {\n            pasenatedistricts {\n                " + props + "\n            }\n        }", {}, 'GET', 'pasenatedistricts')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllCongressionalDistricts = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetCongressionalDistricts {\n            uscongressionaldistricts {\n                " + props + "\n            }\n        }", {}, 'GET', 'uscongressionaldistricts')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllStateRoutes = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetStateRoutes {\n            stateRoutes {\n                " + props + "\n            }\n        }", {}, 'GET', 'stateRoutes')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getStateRoutesByCounty = function (countyCode, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetStateRoutes($countyCode: [String]) {\n            stateRoutes(countyCode: $countyCode) {\n                " + props + "\n            }\n        }", { countyCode: countyCode }, 'GET', 'stateRoutes')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getStateRoutesByCountyJuris = function (countyCode, jurisValues, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var jurisValuesAsStrings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        jurisValuesAsStrings = jurisValues.map(function (x) { return x.toString(); });
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query GetStateRoutes($countyCode: [String], $jurisValuesAsStrings: [String]) {\n            stateRoutes(countyCode: $countyCode, juris: $jurisValuesAsStrings) {\n                " + props + "\n            }\n        }", { countyCode: countyCode, jurisValuesAsStrings: jurisValuesAsStrings }, 'GET', 'stateRoutes')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllSegments = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSegments {\n            rmssegments {\n                " + props + "\n            }\n        }", {}, 'GET', 'rmssegments')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getSegmentsByCountyAndRoute = function (countyCode, routeNumber, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSegments($countyCode: [String], $routeNumber: [String]) {\n            rmssegments(countyCode: $countyCode, stateRouteNumber: $routeNumber) {\n                " + props + "\n            }\n        }", { countyCode: countyCode, routeNumber: routeNumber }, 'GET', 'rmssegments')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getSegmentsNearLatLong = function (latitude, longitude, tolerance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSegments($latitude: [Float], $longitude: [Float], $tolerance: [Float]) {\n            rmssegments(latitude: $latitude, longitude: $longitude, buffer: $tolerance, orderBy: [\"countyCode\", \"stateRouteNumber\", \"segmentNumber\"]) {\n                countyCode,\n                stateRouteNumber,\n                segmentNumber\n            }\n        }", { latitude: latitude, longitude: longitude, tolerance: tolerance }, 'GET', 'rmssegments')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getSegmentsClosestToLatLong = function (latitude, longitude, tolerance, juris) {
        if (juris === void 0) { juris = ['1', '5']; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSegments($latitude: [Float], $longitude: [Float], $juris: [String], $tolerance: [Float]) {\n            rmssegments(latitude: $latitude, longitude: $longitude, juris: $juris, buffer: $tolerance, orderBy: [\"distanceFromLatitudeLongitude\"]) {\n                countyCode,\n                stateRouteNumber,\n                segmentNumber,\n                distanceFromLatitudeLongitude\n            }\n        }", { latitude: latitude, longitude: longitude, juris: juris, tolerance: tolerance }, 'GET', 'rmssegments')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getInterstatesByNetworkIndicator = function (interstateNetworkIndicator) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetSegments($interstateNetworkIndicator: [String]) {\n            rmssegments(interstateNetworkIndicator: $interstateNetworkIndicator) {\n                stateRouteNumber\n            }\n        }", { interstateNetworkIndicator: interstateNetworkIndicator }, 'GET', 'rmssegments')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getAllColumnIdentifiers = function (props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetColumnIdentifiers {\n            columnIdentifiers {\n                " + props + "\n            }\n        }", {}, 'GET', 'columnIdentifiers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getColumns = function (layerId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetColumns($layerId: [Int]) {\n            layers(id: $layerId) {\n                columns {\n                    " + props + "\n                }\n            }\n        }", { layerId: layerId }, 'GET', 'layers')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getOffsetForLatLong = function (lat, long, buffer, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetOffsetForLatLong($lat: [Float], $long: [Float], $buffer: [Float]) {\n            rmsOffset(latitude: $lat, longitude: $long, buffer: $buffer) {\n                " + props + "\n            }\n        }", { lat: lat, long: long, buffer: buffer }, 'GET', 'rmsOffset')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getOffsetForCRSLatLong = function (lat, long, county, route, buffer, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetOffsetForLatLong($lat: [Float], $long: [Float], $county: [String], $route: [String], $buffer: [Float]) {\n            rmsOffset(latitude: $lat, longitude: $long, countyCode: $county, stateRouteNumber: $route, buffer: $buffer) {\n                " + props + "\n            }\n        }", { lat: lat, long: long, county: county, route: route, buffer: buffer }, 'GET', 'rmsOffset')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getNearbyLocalIntersections = function (lat, long, buffer, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query getNearbyLocalIntersections($lat: [Float], $long: [Float], $buffer: [Float]) {\n            rmsintersections(latitude: $lat, longitude: $long, buffer: $buffer) {\n                " + props + "\n            }\n        }", { lat: lat, long: long, buffer: buffer }, 'GET', 'rmsintersections')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getLatLongForOffset = function (cty, rte, seg, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!offset) {
                            offset = '0000';
                        }
                        return [4 /*yield*/, this.api.http2.graphqlRequest("query GetLatLongForOffset($cty: [String], $rte: [String], $seg: [String], $offset: [String]) {\n            rmsOffset(countyCode: $cty, stateRouteNumber: $rte, segmentNumber: $seg, offset: $offset) {\n                latLong {\n                    latitude\n                    longitude\n                }\n            }\n        }", { cty: cty, rte: rte, seg: seg, offset: offset }, 'GET', 'rmsOffset')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getVideoLogForSegment = function (cty, rte, seg, year) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetVideoLogForSegment($cty: [String], $rte: [String], $seg: [String], $year:[String]) {\n            videoLog(countyCode: $cty, stateRouteNumber: $rte, segmentNumber: $seg, year: $year) {\n                countyCode\n                countyName\n                stateRouteNumber\n                routeName\n                direction\n                sideIndicator\n                juris\n                segmentNumber\n                streetName\n                oppositeSegmentNumber\n                previousCountyCode\n                previousSegmentNumber\n                nextSegmentNumber\n                segmentLength\n                nextCountyCode\n                year\n                yearRange\n                rootFolder\n                subFolders\n                additionalFolders {\n                    rootFolder\n                    subFolders\n                }\n                isHighDefinition\n                images {\n                imageName1\n                imageName2\n                imageName3\n                imageDate\n                latitude\n                longitude\n                offset\n                fileName\n                sequenceNumber\n                }\n            }\n        }", { cty: cty, rte: rte, seg: seg, year: year }, 'GET', 'videoLog')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getOppositeOffset = function (cty, rte, juris, seg, offset) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetOppositeOffset($cty: [String], $rte: [String], $juris: [String], $seg: [String], $offset: [String]) {\n            oppositeOffset (countyCode: $cty, stateRouteNumber: $rte, juris: $juris, segmentNumber: $seg, offset: $offset) {\n                countyCode\n                stateRouteNumber\n                juris\n                segmentNumber\n                offset\n            }\n        }", { cty: cty, rte: rte, juris: juris, seg: seg, offset: offset }, 'GET', 'oppositeOffset')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getFeaturesByObjectId = function (pluralObjectName, props, objectIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query " + pluralObjectName + " ($objectIds: [Int]) {\n            " + pluralObjectName + " (objectId: $objectIds) {\n                " + props + "\n            }\n        }", { objectIds: objectIds }, 'GET', "" + pluralObjectName)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.prototype.getRailCrossing = function (crossingId, props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("query GetRailCrossing($crossingId: [String]) {\n            railCrossing(crossingNumber: $crossingId) {\n                " + props + "\n            }\n        }", { crossingId: crossingId }, 'GET', 'railCrossing')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    GisToolsApi.ngInjectableDef = i0.defineInjectable({ factory: function GisToolsApi_Factory() { return new GisToolsApi(i0.inject(i1.Api)); }, token: GisToolsApi, providedIn: "root" });
    return GisToolsApi;
}());
export { GisToolsApi };
